var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1429 9.82426C19.6171 9.82426 20 10.1993 20 10.6615C20 15.7876 15.9719 20.0076 10.8575 20.4356L10.8571 23.1628C10.8571 23.6249 10.4731 24 10 24C9.52686 24 9.14286 23.6249 9.14286 23.1628L9.14365 20.4357C4.02873 20.0082 0 15.788 0 10.6615C0 10.1993 0.384 9.82426 0.857143 9.82426C1.33143 9.82426 1.71429 10.1993 1.71429 10.6615C1.71429 15.1467 5.43086 18.7969 10 18.7969C14.5691 18.7969 18.2857 15.1467 18.2857 10.6615C18.2857 10.1993 18.6697 9.82426 19.1429 9.82426ZM10 0C13.032 0 15.4994 2.41898 15.4994 5.39274V10.6259C15.4994 13.5985 13.032 16.0175 10 16.0175C6.968 16.0175 4.50057 13.5985 4.50057 10.6259V5.39274C4.50057 2.41898 6.968 0 10 0ZM10 1.67442C7.91314 1.67442 6.21486 3.34214 6.21486 5.39274V10.6259C6.21486 12.6742 7.91314 14.3431 10 14.3431C12.0869 14.3431 13.7851 12.6742 13.7851 10.6259V5.39274C13.7851 3.34214 12.0869 1.67442 10 1.67442Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract1);
export default __webpack_public_path__ + "static/media/Subtract1.6d1e3adbdf7f3aeed4ed8d3e421bc1fe.svg";
export { ForwardRef as ReactComponent };